import styled from 'styled-components'

export const StyledAddressItem = styled.div`
  line-height: 1.4;
`
